$shm_hitalama_components_drafts_editor $mol_page
	model $shm_hitalama_components_drafts_model
	selected \
	editing? false
	removed? null
	focus_end* null
	title \Редактирование
	title_content /
		<= Name $mol_string_button
			value? <=> name? \
			hint \Название черновика
	minimal_width 480
	auto / <= focus_auto null
	tools /
		<= Delete $shm_confirm_delete
			title \Удалить черновик
			confirmed? <=> remove? null
		<= Close $mol_button_minor
			hint \Закрыть редактирование
			click? <=> close? null
			sub / <= Close_icon $mol_icon_close
	body /
		<= Text $shm_hitalama_text_editor
			value? <=> text? \
			owner <= image_owner $giper_baza_entity
